import { createGtm } from '@gtm-support/vue-gtm';

export const GTM_ID = 'GTM-NBZQ8MR';

export const gtm = (router) => createGtm({
    id: GTM_ID,
    debug: true,
    vueRouter: router
});
